(function ($) {
  'use strict';

  /**
   * Atreemo API Form
   */

  var $from_category_select = $( '.js-atreemo-form-cat' );
  var $form_template_container = $('#js-atreemo-tmpl-form-container');
  var default_form_category = '';

  // Init Form
  // - Open default category form group
  if ( $from_category_select.length ) {
    default_form_category = $from_category_select.val();

    if ( default_form_category ) {
      var $default_template = get_atreemo_form_template_by_id( default_form_category );
      var template_content = '';

      if ( $default_template.length ) {
        template_content = $default_template.html();
        $form_template_container.append( template_content );
      }
    }
  }


  // Category Select
  // - Change displayed form fields when selecting category
  $from_category_select.on('change', function () {
    var $this = $(this);
    var this_id = $this.val();
    var $this_template = get_atreemo_form_template_by_id( this_id );
    var template_content = '';

    if ( $this_template.length ) {
      template_content = $this_template.html();
      $form_template_container.empty();
      $form_template_container.append( template_content );
      // Update live region
      update_category_live_region( this_id );
    }
  });


  // helper - Get form template
  function get_atreemo_form_template_by_id( id ) {
    var template_id = 'tmpl-form-' + id;
    var $template = $( '#' + template_id );
    return $template;
  }


  // a11y - Update category live rgion
  function update_category_live_region( category_id ) {
    var $category_live_region = $('.js-form-category-live-region');
    var live_message = $category_live_region.data( 'live-message' );
    var form_title = $from_category_select
      .find( 'option[value="' + category_id + '"]' )
      .text();
    console.log( live_message + ': ' + form_title.trim() );
    $category_live_region.text( live_message + ': ' + form_title.trim() );
  }

})(jQuery);
